const API_ORIGIN = process.env.REACT_APP_API_ORIGIN
  || (process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')
    : 'http://localhost:5000');

export const resolveMediaUrl = (value, fallback = '') => {
  if (!value || typeof value !== 'string') {
    return fallback;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return fallback;
  }

  if (/^https?:\/\//i.test(trimmedValue)) {
    return trimmedValue;
  }

  if (trimmedValue.startsWith('/')) {
    return `${API_ORIGIN}${trimmedValue}`;
  }

  return trimmedValue;
};
